import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import toast from "react-hot-toast";
import Box from '../../components/Box';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import RefreshButton from '../../components/RefreshButton';
import ColumnChooser from '../../components/ColumnChooser';
import TableConstantActions from '../../components/TableConstantActions';
import CustomDatePicker from '../../components/CustomDatePicker';
import CustomTextInput from '../../components/CustomTextInput';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../components/CustomSingleSelect';
import CustomMultiSelect, { CustomMultiSelectModel } from '../../components/CustomMultiSelect';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import { kolonlariBirlestir } from '../../components/ColumnFilter/kolonBirlestir';
import ColumnFilterRow from '../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, foldText } from '../../components/ColumnFilter/ColumnFilterTypes';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { PersonnelService } from '../../services/PersonnelService';
import {
    VardiyaAtamasiItem, VardiyaCizelgeHucresi, VardiyaCizelgePersoneli, VardiyaCizelgesiYaniti, VardiyaPlaniItem, VardiyaService
} from '../../services/VardiyaService';
import { IZIN_RENGI, TATIL_KODU, vardiyaRengi } from '../../helpers/vardiyaDesen';
import { DesenSeridi } from './VardiyaPlaniList';
import TakasIstekleri from './TakasIstekleri';
import { TakasItem } from '../../services/VardiyaService';
import { IZIN_BEKLIYOR } from '../../services/IzinService';

const GUN = 28;

/** Atamalar sekmesi: süzme / sıralama için satırın kolon değeri. */
const kolonDegeri = (x: VardiyaAtamasiItem, kolon: string): string => {
    switch (kolon) {
        case 'personelAdi': return x.personelAdi ?? '';
        case 'planAdi': return x.planAdi;
        case 'baslangic': return x.baslangic;
        case 'bitis': return x.bitis ?? '9999';
        case 'giren': return x.giren ?? '';
        default: return '';
    }
}

interface EkranFiltresi {
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
}

interface SeciliHucre {
    personel: VardiyaCizelgePersoneli
    hucre: VardiyaCizelgeHucresi
}

/**
 * Vardiya Çizelgesi (İnsan Kaynakları, Faz 2, 03.11.2026). Çizelge: personel × gün, plandan çözülen vardiya; hücreye tıklayınca
 * o güne başka vardiya / hafta tatili verilir (takas) ya da plana dönülür. Atamalar: personele plan ve başlangıç günü (desenin 1. günü).
 * Yasal uyarılar (11 saat dinlenme, 7 gün üst üste) kaydı durdurmaz, kırmızı köşe ve listede görünür.
 */
const VardiyaCizelgesi = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Vardiya Çizelgesi"
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const formRef = useRef<any>(null);

    // Zildeki 'gün değişimi isteği' satırından gelince istekler sekmesi açılır.
    const location = useLocation();
    const [sekme, setSekme] = useState<'cizelge' | 'atama' | 'takas'>(location.state ? 'takas' : 'cizelge');
    const [takaslar, setTakaslar] = useState<TakasItem[]>([]);
    const [bas, setBasTarih] = useState<string>(moment().startOf('isoWeek').format('YYYY-MM-DD'));
    const [cizelge, setCizelge] = useState<VardiyaCizelgesiYaniti | undefined>(undefined);
    const [secili, setSecili] = useState<SeciliHucre | undefined>(undefined);
    const [hucreAciklama, setHucreAciklama] = useState<string | undefined>(undefined);

    const [atamalar, setAtamalar] = useState<VardiyaAtamasiItem[]>([]);
    const [planlar, setPlanlar] = useState<VardiyaPlaniItem[]>([]);
    const [filter, setFilter] = useState<EkranFiltresi>({ sortColumn: 'personelAdi', sortDirection: 'asc', columnFilters: [] });
    const [isOpen, setIsOpen] = useState(false);
    const [duzenlenenId, setDuzenlenenId] = useState<string | undefined>(undefined);
    const [personeller, setPersoneller] = useState<CustomMultiSelectModel[]>([]);
    const [plan, setPlan] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [atamaBas, setAtamaBas] = useState<string | undefined>(undefined);
    const [atamaBit, setAtamaBit] = useState<string | undefined>(undefined);

    const bit = moment(bas).add(GUN - 1, 'days').format('YYYY-MM-DD');

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Personel', name: 'personelAdi', order: 0, isVisible: true },
            { title: 'Plan', name: 'planAdi', order: 0, isVisible: true },
            { title: 'Desen', name: 'desen', order: 0, isVisible: true },
            { title: 'Başlangıç', name: 'baslangic', order: 0, isVisible: true },
            { title: 'Bitiş', name: 'bitis', order: 0, isVisible: true },
            { title: 'Giren', name: 'giren', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    useEffect(() => { getData(); }, [bas])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var [c, a, p, t] = await Promise.all([VardiyaService.cizelge(bas, bit), VardiyaService.atamaListesi(), VardiyaService.planListesi(), VardiyaService.takasListesi()]);

            if (!c.isSuccess) {
                toast.error(c.message ?? '');
                return;
            }

            setCizelge(c.data);
            if (a.isSuccess) setAtamalar((a.data ?? []).map(x => ({ ...x, isSelected: false })));
            if (p.isSuccess) setPlanlar(p.data ?? []);
            if (t.isSuccess) setTakaslar(t.data ?? []);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const kodlar = (cizelge?.vardiyalar ?? []).map(x => x.kod);
    const kaydir = (gun: number) => { setSecili(undefined); setBasTarih(moment(bas).add(gun, 'days').format('YYYY-MM-DD')); }

    // ---------------------------------------------------------------- Çizelge hücresi

    const hucreSec = (personel: VardiyaCizelgePersoneli, hucre: VardiyaCizelgeHucresi) => {
        if (!menu?.canUpdate)
            return;
        setSecili({ personel, hucre });
        setHucreAciklama(hucre.aciklama ?? undefined);
        setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }

    const gunDegistir = async (vardiyaTanimiId: string | null, tatil: boolean, planaDon: boolean) => {
        if (!secili)
            return;
        try {
            dispatch(storeActivityIndicator(true));
            var response = await VardiyaService.gunDegistir({
                personnelId: secili.personel.personnelId, tarih: secili.hucre.tarih, vardiyaTanimiId, tatil, planaDon,
                aciklama: hucreAciklama && hucreAciklama.trim() != '' ? hucreAciklama.trim() : null
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(planaDon ? "Gün plana döndü." : "Gün değiştirildi. O günün mesai kaydı varsa yeniden hesaplandı.");
            setSecili(undefined);
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const hucreIcerik = (h: VardiyaCizelgeHucresi) => {
        var renk = h.izinKodu ? IZIN_RENGI : vardiyaRengi(h.kod, kodlar);
        var baslik = [
            h.izinKodu ? `${h.izinKodu} · ${h.izinAdi}` : null,
            h.kod == TATIL_KODU ? 'Hafta tatili' : h.saat ? `${h.kod} ${h.saat}` : null,
            h.degisiklik ? 'Günlük değişiklik' + (h.aciklama ? `: ${h.aciklama}` : '') : null,
            h.uyari
        ].filter(x => x).join('\n');

        return (
            <div title={baslik} style={{
                ...renk, position: 'relative', borderRadius: 4, padding: '4px 0', minWidth: 34, textAlign: 'center', fontWeight: 600,
                outline: h.degisiklik ? '1px dashed currentColor' : undefined, cursor: menu?.canUpdate ? 'pointer' : undefined
            }}>
                {h.izinKodu ?? h.kod ?? '·'}
                {h.uyari && <span style={{ position: 'absolute', top: 0, right: 0, width: 0, height: 0, borderTop: '7px solid #F1416C', borderLeft: '7px solid transparent' }} />}
            </div>
        );
    }

    // ---------------------------------------------------------------- Atamalar

    const gorunen = atamalar.filter(x => (filter.columnFilters ?? []).every(f => {
        if (f.values && f.values.length > 0)
            return f.values.includes(kolonDegeri(x, f.column));

        if (f.text && f.text.trim())
            return foldText(kolonDegeri(x, f.column)).includes(foldText(f.text.trim()));

        return true;
    })).sort((a, b) => {
        if (!filter.sortColumn)
            return 0;

        var r = kolonDegeri(a, filter.sortColumn).localeCompare(kolonDegeri(b, filter.sortColumn), 'tr');
        return filter.sortDirection == 'desc' ? -r : r;
    });

    const sortableColumns = ['personelAdi', 'planAdi', 'baslangic', 'bitis', 'giren'];
    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, (f?: EkranFiltresi) => { if (f) setFilter(f); });

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        personelAdi: { type: 'text' },
        planAdi: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => setFilter({ ...filter, columnFilters });

    const setItemSelected = (_id: string) => setAtamalar(atamalar.map(x => x.vardiyaAtamasiId == _id ? { ...x, isSelected: !x.isSelected } : x));

    const selectAll = () => {
        var ids = gorunen.map(x => x.vardiyaAtamasiId);
        var isAllSelected = gorunen.length > 0 && gorunen.every(x => x.isSelected);
        setAtamalar(atamalar.map(x => ids.includes(x.vardiyaAtamasiId) ? { ...x, isSelected: !isAllSelected } : x));
    }

    const secililer = atamalar.filter(x => x.isSelected);

    const formuDoldur = (o: VardiyaAtamasiItem | undefined) => {
        setDuzenlenenId(o?.vardiyaAtamasiId);
        setPersoneller(o ? [{ label: o.personelAdi ?? '', value: o.personnelId }] : []);
        setPlan(o ? { label: o.planAdi, value: o.vardiyaPlaniId } : undefined);
        setAtamaBas(o?.baslangic?.substring(0, 10));
        setAtamaBit(o?.bitis?.substring(0, 10));
    }

    const yeniAtama = () => { formuDoldur(undefined); setIsOpen(true); setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50); }
    const atamaIptal = () => { formuDoldur(undefined); setIsOpen(false); }

    const atamaAc = (o: VardiyaAtamasiItem | undefined) => {
        if (!o || !menu?.canUpdate)
            return;
        formuDoldur(o);
        setIsOpen(true);
        setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }

    const personelSecenekleri = async () => {
        var response = await PersonnelService.getPersonnelList(undefined, true);
        return {
            isSuccess: response.isSuccess,
            data: (response.data ?? []).map((x: any) => ({ label: x.nameSurname, value: x.personnelId }))
        };
    }

    const atamaKaydet = async () => {
        try {
            if (personeller.length == 0) { toast.error("Personel alanı zorunludur."); return; }
            if (!plan?.value) { toast.error("Plan alanı zorunludur."); return; }
            if (!atamaBas) { toast.error("Başlangıç tarihi zorunludur."); return; }
            if (atamaBit && atamaBit < atamaBas) { toast.error("Bitiş tarihi başlangıçtan önce olamaz."); return; }

            dispatch(storeActivityIndicator(true));

            var response = await VardiyaService.atamaKaydet({
                vardiyaAtamasiId: duzenlenenId ?? null,
                personnelIdler: personeller.map(x => x.value),
                vardiyaPlaniId: plan.value,
                baslangic: atamaBas,
                bitis: atamaBit ?? null
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(`${response.data?.length ?? 0} personele plan atandı. Faturalanmamış mesai kayıtları vardiyaya göre yeniden hesaplandı.`);
            atamaIptal();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const atamaSil = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await VardiyaService.atamaSil(secililer.map(x => x.vardiyaAtamasiId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("Seçilen atamalar kaldırıldı; bu kişiler yeniden Çalışma Saatleri'ne göre hesaplanır.");
            atamaIptal();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const atamaHucre = (item: VardiyaAtamasiItem, column: string) => {
        var icerik: React.ReactNode;

        if (column == 'personelAdi')
            icerik = item.personelAdi;
        else if (column == 'planAdi')
            icerik = item.planAdi;
        else if (column == 'desen')
            icerik = <DesenSeridi desen={planlar.find(p => p.vardiyaPlaniId == item.vardiyaPlaniId)?.desen ?? ''} kodlar={kodlar} />;
        else if (column == 'baslangic')
            icerik = item.baslangicStr;
        else if (column == 'bitis')
            icerik = item.bitisStr ?? <span className='text-muted'>Süresiz</span>;
        else if (column == 'giren')
            icerik = <React.Fragment>{item.giren}<br /><span className='text-muted fs-8'>{item.tarih}</span></React.Fragment>;

        return <td key={column} onClick={() => setItemSelected(item.vardiyaAtamasiId)} onDoubleClick={() => atamaAc(item)}>{icerik}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort((a, b) => a.order - b.order);
    const seciliPlan = planlar.find(p => p.vardiyaPlaniId == plan?.value);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                {
                    sekme == 'cizelge' ? (
                        <div className='m-0 d-flex align-items-center gap-2'>
                            <a className='btn btn-sm btn-light' title='Önceki 4 hafta' onClick={() => kaydir(-GUN)}>‹</a>
                            <input type='date' className='form-control form-control-sm form-control-solid' style={{ width: 150 }} title='Başlangıç' value={bas}
                                onChange={(e) => e.target.value && setBasTarih(e.target.value)} />
                            <span className='text-muted fs-7'>– {moment(bit).format('DD.MM.YYYY')}</span>
                            <a className='btn btn-sm btn-light' title='Sonraki 4 hafta' onClick={() => kaydir(GUN)}>›</a>
                            <a className='btn btn-sm btn-light' onClick={() => setBasTarih(moment().startOf('isoWeek').format('YYYY-MM-DD'))}>Bu hafta</a>
                        </div>
                    ) : sekme == 'atama' ? (
                        <React.Fragment>
                            <TableConstantActions
                                deleteFunction={atamaSil}
                                onSearchSubmit={(e) => e.preventDefault()}
                                pageName={pageName}
                                hideSearch={true}
                                searchTerm=''
                                selectedCount={secililer.length}
                                setSearchTerm={() => { }}
                                updateFunction={() => atamaAc(secililer[0])}
                            />

                            <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

                            {
                                menu?.canInsert && (
                                    <div className='m-0'>
                                        <a onClick={yeniAtama} className='btn btn-sm fw-bold btn-primary'>Yeni Atama</a>
                                    </div>
                                )
                            }
                        </React.Fragment>
                    ) : null
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <ul className='nav nav-tabs nav-line-tabs mb-4 fs-6'>
                    <li className='nav-item'>
                        <a className={'nav-link ' + (sekme == 'cizelge' ? 'active' : '')} style={{ cursor: 'pointer' }} onClick={() => setSekme('cizelge')}>Çizelge</a>
                    </li>
                    <li className='nav-item'>
                        <a className={'nav-link ' + (sekme == 'atama' ? 'active' : '')} style={{ cursor: 'pointer' }} onClick={() => { setSekme('atama'); setSecili(undefined); }}>
                            Atamalar <span className='badge badge-light ms-1'>{atamalar.length}</span>
                        </a>
                    </li>
                    <li className='nav-item'>
                        <a className={'nav-link ' + (sekme == 'takas' ? 'active' : '')} style={{ cursor: 'pointer' }} onClick={() => { setSekme('takas'); setSecili(undefined); }}>
                            Gün Değişimi İstekleri
                            {takaslar.some(x => x.durum == IZIN_BEKLIYOR) && <span className='badge badge-light-warning ms-1'>{takaslar.filter(x => x.durum == IZIN_BEKLIYOR).length} onay bekliyor</span>}
                        </a>
                    </li>
                </ul>

                {
                    sekme == 'cizelge' && secili && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-2 text-black">{secili.personel.personelAdi} · {moment(secili.hucre.tarih).format('DD.MM.YYYY dddd')}</h4>
                                    <div className="text-muted fs-7 mb-5">
                                        Şu an: <b>{secili.hucre.kod == TATIL_KODU ? 'Hafta tatili' : secili.hucre.kod ? `${secili.hucre.kod} ${secili.hucre.saat}` : 'Plan yok'}</b>
                                        {secili.hucre.degisiklik && ' (günlük değişiklik)'}
                                        {secili.hucre.izinKodu && ` · İzinli: ${secili.hucre.izinAdi}`}
                                    </div>

                                    <div className="d-flex flex-wrap gap-2">
                                        {
                                            (cizelge?.vardiyalar ?? []).filter(v => v.aktif).map(v =>
                                                <button key={v.vardiyaTanimiId} className='btn btn-sm' style={{ ...vardiyaRengi(v.kod, kodlar), border: secili.hucre.vardiyaTanimiId == v.vardiyaTanimiId ? '2px solid currentColor' : '1px solid transparent' }}
                                                    onClick={() => gunDegistir(v.vardiyaTanimiId, false, false)}>
                                                    <b>{v.kod}</b> {v.baslangic}–{v.bitis}
                                                </button>
                                            )
                                        }
                                        <button className='btn btn-sm' style={{ ...vardiyaRengi(TATIL_KODU, kodlar), border: secili.hucre.tatil ? '2px solid currentColor' : '1px solid transparent' }}
                                            onClick={() => gunDegistir(null, true, false)}>
                                            <b>HT</b> Hafta tatili
                                        </button>
                                        {
                                            secili.hucre.degisiklik && (
                                                <button className='btn btn-sm btn-light-primary' onClick={() => gunDegistir(null, false, true)}>Plana dön</button>
                                            )
                                        }
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-md-8">
                                            <CustomTextInput labelText="Açıklama (ör. Veli ile takas)" value={hucreAciklama} setValue={setHucreAciklama} />
                                        </div>
                                    </div>

                                    <div className="text-muted fs-7 mt-4">
                                        Değişiklik yalnız bu güne uygulanır, plan aynı kalır. O günün faturalanmamış mesai kaydı yeni vardiyaya göre yeniden hesaplanır.
                                    </div>

                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-4">
                                        <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => setSecili(undefined)}>Kapat</button>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                {
                    sekme == 'cizelge' && (
                        <KTCard className='mb-3'>
                            <KTCardBody className='py-3'>
                                <div className='d-flex flex-wrap align-items-center gap-3 fs-8 mb-3'>
                                    {(cizelge?.vardiyalar ?? []).map(v =>
                                        <span key={v.vardiyaTanimiId} className='d-flex align-items-center gap-1'>
                                            <span className='badge' style={vardiyaRengi(v.kod, kodlar)}>{v.kod}</span>{v.ad} {v.baslangic}–{v.bitis}
                                        </span>
                                    )}
                                    <span className='d-flex align-items-center gap-1'><span className='badge' style={vardiyaRengi(TATIL_KODU, kodlar)}>HT</span>hafta tatili</span>
                                    <span className='d-flex align-items-center gap-1'><span className='badge' style={IZIN_RENGI}>Yİ</span>izin / rapor</span>
                                    <span className='text-muted'>kesik çerçeve: günlük değişiklik · kırmızı köşe: yasal uyarı</span>
                                </div>

                                <div className='table-responsive'>
                                    <table className='table table-bordered align-middle mb-0' style={{ fontSize: 12 }}>
                                        <thead>
                                            <tr className='text-muted fw-bold'>
                                                <th style={{ position: 'sticky', left: 0, background: '#fff', zIndex: 1, minWidth: 170 }}>Personel</th>
                                                {(cizelge?.gunler ?? []).map(g =>
                                                    <th key={g.tarih} className='text-center p-1' title={g.ozelGun ?? undefined}
                                                        style={{ minWidth: 38, background: g.ozelGun ? '#FCE4C4' : (g.haftaGunu == 'Cmt' || g.haftaGunu == 'Paz') ? '#F9F9F9' : undefined }}>
                                                        <div>{g.gun}</div><div className='fs-9'>{g.haftaGunu}</div>
                                                    </th>
                                                )}
                                                <th className='text-nowrap'>Özet</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (cizelge?.personeller ?? []).length == 0 && (
                                                    <tr><td colSpan={99} className='text-center text-muted py-6'>
                                                        Bu aralıkta vardiyalı personel yok. Atamalar sekmesinden personele plan atayın (önce Vardiya Tanımları ve Vardiya Planları).
                                                    </td></tr>
                                                )
                                            }
                                            {
                                                (cizelge?.personeller ?? []).map(p =>
                                                    <tr key={p.personnelId}>
                                                        <td style={{ position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>
                                                            <div className='fw-bold text-gray-800'>{p.personelAdi}</div>
                                                            <div className='text-muted fs-9'>{p.planAdi ?? ''}</div>
                                                        </td>
                                                        {p.gunler.map(h =>
                                                            <td key={h.tarih} className='p-1' onClick={() => hucreSec(p, h)}
                                                                style={{ background: secili?.personel.personnelId == p.personnelId && secili.hucre.tarih == h.tarih ? '#E8F1FF' : undefined }}>
                                                                {hucreIcerik(h)}
                                                            </td>
                                                        )}
                                                        <td className='text-nowrap fs-8'>{Object.entries(p.ozet).map(([k, n]) => `${k} ${n}`).join(' · ')}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                {
                                    (cizelge?.uyarilar ?? []).length > 0 && (
                                        <div className='mt-4 p-3 rounded' style={{ background: '#FFF5F8' }}>
                                            <div className='fw-bold text-danger fs-7 mb-1'>Yasal uyarılar ({cizelge!.uyarilar.length})</div>
                                            <div className='fs-8 text-gray-700'>{cizelge!.uyarilar.map((u, i) => <div key={i}>{u}</div>)}</div>
                                        </div>
                                    )
                                }
                            </KTCardBody>
                        </KTCard>
                    )
                }

                {
                    sekme == 'takas' && (
                        <TakasIstekleri liste={takaslar} kodlar={kodlar} kararYetkisi={!!menu?.canUpdate} yenile={getData} />
                    )
                }

                {
                    sekme == 'atama' && isOpen && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-10 text-black">{duzenlenenId ? 'Atamayı Güncelle' : 'Yeni Atama'}</h4>

                                    <div className="row">
                                        <div className="col-md-4">
                                            {
                                                duzenlenenId ? (
                                                    <CustomTextInput labelText="Personel" isDisabled value={personeller[0]?.label} setValue={undefined} />
                                                ) : (
                                                    <CustomMultiSelect
                                                        menuPortal
                                                        labelText="Personel (birden çok seçilebilir)"
                                                        isLabelRequired
                                                        selectedValues={personeller}
                                                        onChange={setPersoneller}
                                                        onMenuOpen={personelSecenekleri}
                                                        labelName='label'
                                                        valueName='value'
                                                        insertable={undefined}
                                                        disabled={false}
                                                        additionalValue1Name={undefined}
                                                        innerPropName={undefined}
                                                    />
                                                )
                                            }
                                        </div>
                                        <div className="col-md-3">
                                            <CustomSingleSelect
                                                menuPortal
                                                labelText="Vardiya planı"
                                                isLabelRequired
                                                selectedValue={plan}
                                                onChange={setPlan}
                                                onMenuOpen={() => Promise.resolve({ isSuccess: true, data: planlar.filter(x => x.aktif).map(x => ({ label: x.ad, value: x.vardiyaPlaniId })) })}
                                                labelName='label'
                                                valueName='value'
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <CustomDatePicker labelText="Başlangıç" isLabelRequired value={atamaBas} setValue={setAtamaBas} />
                                        </div>
                                        <div className="col-md-2">
                                            <CustomDatePicker labelText="Bitiş" value={atamaBit} setValue={setAtamaBit} />
                                        </div>
                                    </div>

                                    {seciliPlan && <div className='mt-4'><DesenSeridi desen={seciliPlan.desen} kodlar={kodlar} /></div>}

                                    <div className="text-muted fs-7 mt-4">
                                        Başlangıç günü desenin 1. günüdür; desen döner. Bitiş boşsa süresiz. Aynı kişiye çakışan iki plan girilemez: plan değişecekse eskisinin bitişini girin.
                                        {' '}Kaydedince bu kişilerin başlangıçtan itibaren (en çok 62 gün geriye) faturalanmamış mesai kayıtları vardiyaya göre yeniden hesaplanır.
                                    </div>

                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-5">
                                        <Box mr="15px">
                                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={atamaIptal}>İptal Et</button>
                                        </Box>
                                        <Box>
                                            <button className="btn btn-primary btn-sm" onClick={atamaKaydet}>Kaydet</button>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                {
                    sekme == 'atama' && (
                        <KTCard className='mb-3'>
                            <KTCardBody className='py-2'>
                                <ColumnFilterChips columns={columns} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} />

                                <div className='table-responsive new-table-container'>
                                    <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                        <thead>
                                            <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                <th style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={selectAll} className='form-check-input' type='checkbox' checked={gorunen.length > 0 && gorunen.every(x => x.isSelected)} />
                                                        </label>
                                                    </div>
                                                </th>
                                                {gorunenKolonlar.map(item => <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>)}
                                            </tr>
                                            <ColumnFilterRow columns={gorunenKolonlar} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} leadingCellCount={1} />
                                        </thead>
                                        <tbody className='text-gray-600 fw-bold'>
                                            {
                                                gorunen.length == 0 && (
                                                    <tr><td className="text-center" colSpan={99}>Kayıt bulunamadı.</td></tr>
                                                )
                                            }
                                            {
                                                gorunen.map(item =>
                                                    <tr key={item.vardiyaAtamasiId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                        <td style={{ width: 1 }}>
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.vardiyaAtamasiId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                                </label>
                                                            </div>
                                                        </td>
                                                        {gorunenKolonlar.map(c => atamaHucre(item, c.name))}
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                <div className="text-muted fs-7 py-3">{gorunen.length} kayıt</div>
                            </KTCardBody>
                        </KTCard>
                    )
                }
            </Content>
        </React.Fragment>
    )
}

export default VardiyaCizelgesi;
